import { useMutation } from '@tanstack/react-query';
import { serializeCoupon } from '../server/serializers';
import useResponseHandler from './useResponseHandler';
import { buyCoupon } from '../server/requests';
import { convertSelectionsToBig9Format } from './helpers';

const useBuyCoupon = ({
    extId,
    poolId,
    combinationPrice,
    combinationCount,
    selections,
    couponId,
}) => {
    const preparePayload = () => ({
        couponId,
        ...serializeCoupon({
            poolId,
            extId,
            combinationPrice,
            combinationCount,
            selections: convertSelectionsToBig9Format(selections, true),
        }),
    });

    const { handleResponse } = useResponseHandler({
        requestHandler: buyCoupon,
    });

    const mutationFn = async () => {
        const payload = preparePayload();
        return await handleResponse(payload);
    };

    const mutation = useMutation(mutationFn);

    return {
        status: mutation,
        buyCoupon: mutation.mutateAsync,
        reset: mutation.reset,
        error: mutation.error?.message,
        isError: mutation.isError,
    };
};

export default useBuyCoupon;
